import { useState, useEffect } from "react";
import { IoMdClose } from "react-icons/io";
import SelectDataSourceModal from "../SelectDataSourceModal";
import { DataState } from "../../context/DataProvider";
import { createTempBot } from "../../services/api";

import { integrationData } from "../../utils/constants";
import Button from "../custom/Button";
import DataFunction from "./DataFunction";
import SelectedTriggerItem from "../form/SelectedTriggerItem";

const DataApps = ({ isModalOpen, closeModal, setSelectedValue }) => {
  const [isIntegrationModalOpen, setIsIntegrationModalOpen] = useState(false);

  const [selectTrigerOptions, setSelectTrigerOptions] = useState([]);
  const [selectIntegrationOptions, setSelectIntegrationOptions] = useState([]);
  const [selectDataSourceOptions, setSelectDataSourceOptions] = useState([]);
  const {
    createAndHandleClarificationQuestions,
    setError,
    botCreationId,
    setBotCreationId,
    userGoogleId,
  } = DataState();
  const [editOption, setEditOption] = useState(null);
  const [triggerName, setTriggerName] = useState(""); // State for storing the trigger name
  const [instruction, setInstruction] = useState(""); // State for storing the instruction

  useEffect(() => {
    if (isModalOpen) {
      const createBot = async () => {
        try {
          const response = await createTempBot({
          }, userGoogleId);
          if (response.error) {
            setError(JSON.stringify(response.error));
            return;
          }
          if (response.bot_id) {
            setBotCreationId(response.bot_id);
          }
        } catch (err) {
          setError(JSON.stringify(err));
        }
      };
      createBot();
    }
  }, [isModalOpen]);

  const handleDeleteIntegrationOption = (optionId) => {
    setSelectIntegrationOptions((prev) =>
      prev.filter((item) => item.id !== optionId)
    );
  };

  const handleIntergrationEditOption = (option) => {
    setEditOption(option);
    setIsIntegrationModalOpen(true);
  };

  const [showQuestionForm, setShowQuestionForm] = useState();
  const [showTestScreen, setShowTestScreen] = useState();
  const [isFormLoading, setIsFormLoading] = useState(false);
  const handleNewInstructionSubmission = async () => {
    // setIsFormLoading(true);
    // try {
    //   const final_response = await createAndHandleClarificationQuestions(
    //     instruction,
    //     triggerName,
    //     selectTrigerOptions,
    //     selectIntegrationOptions,
    //     selectDataSourceOptions
    //   );
    //   if (final_response && final_response.questions) {
    //     setShowQuestionForm(true);
    //   } else {
    //     console.log("No Questions Returned");
    //   }
    // } catch (error) {
    // } finally {
    //   setIsFormLoading(false);
    // }
  };

  return (
    <div
      className={`fixed top-0 left-0 bg-black bg-opacity-20 backdrop-blur-sm w-screen h-screen items-center justify-center z-[100] transition-all ease-in-out duration-200 ${
        isModalOpen ? "flex" : "hidden"
      }`}
    >
      {!showTestScreen && !showQuestionForm && (
        <div className="bg-1 h-[90%] max-w-3xl w-[90%] rounded-lg overflow-auto">
          <div className="flex justify-between gap-3 border-b br-1 px-3 py-5 text-p-text">
            <input
              className="px-3 py-1.5 text-p-text rounded-lg outline-none resize-none text-xl font-bold bg-2 w-fit text-center"
              value={triggerName}
              onChange={(e) => setTriggerName(e.target.value)}
              placeholder="Untitled Group"
            />
            <div>
              <button
                onClick={closeModal}
                className="bg-1 transition-all duration-200 rounded-lg p-1.5"
              >
                <IoMdClose />
              </button>
            </div>
          </div>
          <div className="flex-grow flex flex-col justify-between gap-8 p-6">
            <div className="flex flex-col gap-2">
              <div className="flex items-center justify-between gap-3 bg-zinc-950 px-3 py-2 rounded-lg">
                <div className="flex flex-col gap-1 ">
                  <h1 className="text-base font-semibold">App integrations</h1>
                  <p className="text-sm">
                    Add applications included in the workflow
                  </p>
                </div>
                <button
                  onClick={() => setIsIntegrationModalOpen(true)}
                  className="px-2 py-1 border border-zinc-200 duration-200 transition-all text-sm rounded-lg"
                >
                  ADD
                </button>
              </div>
              {selectIntegrationOptions.map((item) => (
                <SelectedTriggerItem
                  item={item}
                  handleEditOption={() => handleIntergrationEditOption(item)}
                  handleDeleteOption={handleDeleteIntegrationOption}
                />
              ))}
            </div>
            <div className="flex justify-end">
              <Button
                loading={isFormLoading}
                onClick={handleNewInstructionSubmission}
              >
                Save
              </Button>
            </div>
            {botCreationId && (
              <DataFunction
                title="Add integration"
                desc=" Select the app you’d like to add as integration."
                isOpen={isIntegrationModalOpen}
                onClose={() => {
                  setIsIntegrationModalOpen(false);
                  setEditOption(null);
                }}
                appsData={integrationData}
                selectedOptions={selectIntegrationOptions}
                setSelectedOptions={setSelectIntegrationOptions}
                editOption={editOption}
                botCreationId={botCreationId}
                setSelectedValue={setSelectedValue}
              />
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default DataApps;
